export default "{\n    \"facilityCountLabel\": \"{{count}} instalaciones\"\n}\n"